module.exports = __webpack_public_path__ + "media/images/camera_plus-f3ef610c9ef2a4bff215359dc7352ab2.svg";